import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint implicit-arrow-linebreak: 0 */

import { compose } from 'recompose';
import _find from 'lodash/find';
import _head from 'lodash/head';
import _property from 'lodash/property';

// Factories
import getOperatorForFilterType from '../../factory/filterDialog.operator';
var getSelectedFilterType = function getSelectedFilterType(filterTypes, selectedFilterTypeId) {
  return _find(filterTypes, {
    id: selectedFilterTypeId
  });
};
export var updateFieldOnTypeChange = function updateFieldOnTypeChange(filterTypes, selectedFilterTypeId, rowId, fields) {
  var selectedFilterType = getSelectedFilterType(filterTypes, selectedFilterTypeId);
  var operators = getOperatorForFilterType(selectedFilterType);
  var currentField = fields[rowId];
  return _objectSpread(_objectSpread({}, currentField), {}, {
    renderOptions: _objectSpread(_objectSpread({}, currentField.renderOptions), {}, {
      operators: operators
    })
  });
};
var getDefaultOperatorId = compose(_property('id'), _head, _property('renderOptions.operators'));
export var updateValuesOnTypeChange = function updateValuesOnTypeChange(value, updatedField) {
  var defaultOperator = getDefaultOperatorId(updatedField);
  return _objectSpread(_objectSpread({}, value), {}, {
    values: [],
    operator: defaultOperator
  });
};